import { appConstantSettings } from 'srcReact/appConstantSettings'
import { getBehaviour } from './behaviours'

export const getEUPricing = (t) => {
    return [
        {
            id: 'plan-1',
            title: t('billing.pricing.essentialFree'),
            color: 'gray',
            behaviors: getBehaviour(t).basic,
            priceMonthly: t('billing.pricing.free'),
            priceYearly: t('billing.pricing.free'),
            nameMonthly: 'plan-free-euro',
            nameYearly: 'plan-free-euro',
            withLabel: false,
            contactus: t('billing.pricing.free')
        },
        {
            id: 'plan-2',
            title: t('billing.pricing.essential'),
            color: 'green',
            specialMessage: `${t('billing.pricing.daysFreeTrial', { count: appConstantSettings.FREE_TRIAL_DAYS })}*`,
            specialMsgYearly: true,
            behaviors: getBehaviour(t).essential,
            hasPrice: true,
            priceMonthly: appConstantSettings.EU_MONTHLY_ESSENTIAL,
            priceYearly: appConstantSettings.EU_YEARLY_ESSENTIAL,
            nameMonthly: 'plan-essentials-euro',
            nameYearly: 'plan-essentials-annual-euro',
            withLabel: true,
            infoMessage: t('billing.pricing.availableForYearly'),
            contactus: t('billing.pricing.contactUsBtn')
        },
        {
            id: 'plan-3',
            title: t('billing.pricing.pro'),
            color: 'purple',
            specialMessage: `${t('billing.pricing.daysFreeTrial', { count: appConstantSettings.FREE_TRIAL_DAYS })}*`,
            behaviors: getBehaviour(t).pro,
            hasPrice: true,
            priceMonthly: appConstantSettings.EU_MONTHLY_PRO,
            priceYearly: appConstantSettings.EU_YEARLY_PRO,
            nameMonthly: 'plan-pro-euro',
            nameYearly: 'plan-pro-annual-euro',
            withLabel: true,
            contactus: t('billing.pricing.contactUsBtn')
        },
        {
            id: 'plan-4',
            title: t('billing.pricing.enterprise'),
            color: 'orange',
            behaviors: getBehaviour(t).custom,
            priceMonthly: t('billing.pricing.custom'),
            priceYearly: t('billing.pricing.custom'),
            nameMonthly: 'plan-free-euro',
            nameYearly: 'plan-free-euro',
            withLabel: false,
            contactus: t('billing.pricing.contactUsBtn')
        }
    ]
}